import styled from 'styled-components';

export const Wrapper = styled.div<{ $gap: number }>`
  display: flex;
  gap: ${({ $gap }) => `${$gap}px`};
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: var(--textAndLabels-main);
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;
